<app-calendar
  [events]="calendarEvents"
  [loading]="loading"
  [options]="calendarOptions"
  (rangeChanged)="rangeChanged.emit($event)"></app-calendar>
